import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

const restrictedPaths = [
  {
    path: "/account",
    name: "Account",
    fromEnd: false,
    connectOnly: false,
  },
  {
    path: "/portfolio",
    name: "Portfolio",
    fromEnd: false,
    connectOnly: true,
  },
  {
    path: "/activity",
    name: "Activity",
    fromEnd: false,
    connectOnly: true,
  },
  {
    path: "/season2",
    name: "Cred",
    fromEnd: false,
    connectOnly: true,
  },
  {
    path: "/piggy",
    name: "$PIGGY",
    fromEnd: false,
    connectOnly: true,
  },
  {
    path: "/season1",
    name: "Season 1",
    fromEnd: false,
    connectOnly: true,
  },
  {
    path: "/migrate",
    name: "Migrate",
    fromEnd: false,
    connectOnly: true,
  },
];

export default function useCheckRestrictedPage(): undefined | string {
  const pathname = usePathname();
  const { user } = useDynamicContext();
  const userAddress = useWeb3UserAddress();
  return useMemo(() => {
    const page = restrictedPaths.find(singlePath => (singlePath.fromEnd ? pathname.endsWith(singlePath.path) : pathname.startsWith(singlePath.path)));
    if (!page) {
      return undefined;
    }
    if (page.connectOnly) {
      return userAddress ? undefined : page.name;
    }
    return user ? undefined : page.name;
  }, [pathname, user, userAddress]);
}
